export const Line = ({ css }) => {
  return <hr style={css} />;
};
